import { ListLayout, Toggle } from '@ingrid/luterkort-react';

import { useTranslatedFormLabel } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayBoolean({ schema, path = '' }: Props) {
  const label = useTranslatedFormLabel({ path });

  if (schema.type !== 'boolean') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{label}</ListLayout.SecondaryText>
      <Toggle checked={!!schema.value} aria-label={label} disabled={true} />
    </ListLayout.Stack>
  );
}
